import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { TestslipsComponent } from './work-review/testslips/testslips.component';
import { ViewTestslipsComponent } from './work-review/view-testslips/view-testslips.component';
import { AuthGuard } from '../app/core/authentication/auth.gaurd';
import { NotificationsComponent } from './notifications/notifications/notifications.component';
import { AddNotificationsComponent } from './notifications/add-notifications/add-notifications.component';
import { UnAuthorizedComponent } from './components/un-authorized/un-authorized.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { Roles } from './core/utils';
import { AddOfflineTestslipComponent } from './work-review/add-offline-testslip/add-offline-testslip.component';

const routes: Routes = [

  {
    path: 'dashboard', component: TestslipsComponent, pathMatch: 'full',
    canActivate: [MsalGuard, AuthGuard],
    data: {
      userRoles: [Roles.SUBMIT_VIEW_TEST_SLIP, Roles.REVIEW_TEST_SLIP, Roles.ADMIN,  Roles.TRAINER,
        Roles.TRAINEE, Roles.READ_ONLY]
    }
  },
  {
    path: 'view-testslips', component: ViewTestslipsComponent, pathMatch: 'full',
    canActivate: [MsalGuard, AuthGuard],
    data: {
      userRoles: [Roles.SUBMIT_VIEW_TEST_SLIP, Roles.REVIEW_TEST_SLIP, Roles.ADMIN,  Roles.TRAINER,
        Roles.TRAINEE, Roles.READ_ONLY]
    }
  },
  {
    path: 'add-testslip', component: AddOfflineTestslipComponent, pathMatch: 'full',
    canActivate: [MsalGuard, AuthGuard],
    data: {
      userRoles: [Roles.REVIEW_TEST_SLIP]
    }
  },
  {
    path: 'notification', component: NotificationsComponent, pathMatch: 'full',
    canActivate: [MsalGuard, AuthGuard],
    data: {
      userRoles: [Roles.ADMIN]
    }
  },
  {
    path: 'add-notification', component: AddNotificationsComponent, pathMatch: 'full',
    canActivate: [MsalGuard, AuthGuard],
    data: {
      userRoles: [Roles.ADMIN]
    }
  },
  {
    path: 'admin',
    loadChildren: () => import('./user-management/admin.module').then(m => m.AdminModule),
  },
  {
    path: 'standards',
    loadChildren :() => import('./standards-management/standards.module').then(m => m.StandardsModule),
  },
  {
    path: 'unauthorized', component: UnAuthorizedComponent, pathMatch: 'full',

  },
  {
    path: '', redirectTo: '/dashboard', pathMatch: 'full',
    // canActivate: [MsalGuard, AuthGuard],
    // data: {
    //   userRoles: [Roles.SUBMIT_VIEW_TEST_SLIP,Roles.REVIEW_TEST_SLIP, Roles.ADMIN]
    // }
  },
  {
    path: '*', component: PageNotFoundComponent, pathMatch: 'full',
    canActivate: [MsalGuard, AuthGuard],
    data: {
      userRoles: []
    }
  },
  {
    path: '**', component: PageNotFoundComponent, pathMatch: 'full',
    canActivate: [MsalGuard, AuthGuard],
    data: {
      userRoles: []
    }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
